var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "align-stretch pt-3", attrs: { dense: "" } },
        [
          _vm._t("label", function () {
            return [
              _vm.label && !_vm.hideLabel
                ? _c(
                    "v-col",
                    { attrs: { cols: "6", sm: "6", md: _vm.labelSize } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "d-flex", attrs: { flat: "" } },
                        [
                          _vm.nullable
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-card",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    height: "32",
                                                    flat: "",
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-switch", {
                                                  staticClass: "mt-0",
                                                  attrs: { dense: "" },
                                                  model: {
                                                    value: _vm.nullValue,
                                                    callback: function ($$v) {
                                                      _vm.nullValue = $$v
                                                    },
                                                    expression: "nullValue",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1538822060
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.nullValue ? "Disable" : "Enable"
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c("v-card", { attrs: { flat: "" } }, [
                            _c("span", { staticClass: "text-subtitle-2" }, [
                              _vm._v(_vm._s(_vm.label)),
                            ]),
                            _vm.hint
                              ? _c(
                                  "div",
                                  [
                                    _vm.hint.length > 80
                                      ? [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                top: "",
                                                "max-width": "300",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "text-caption",
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.hint.substring(
                                                                    0,
                                                                    80
                                                                  ) + "..."
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2743448281
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.hint)),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      : _c(
                                          "span",
                                          { staticClass: "text-caption" },
                                          [_vm._v(_vm._s(_vm.hint))]
                                        ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _c("v-spacer"),
          !_vm.nullable || (_vm.nullable && _vm.nullValue)
            ? [
                _vm.chartable && !_vm.chartVisible
                  ? _c(
                      "v-col",
                      { staticClass: "shrink" },
                      [
                        _c("Dialog", {
                          attrs: {
                            icon: "show_chart",
                            tooltip: "Show Trend",
                            title: _vm.chartTitle,
                            loading: _vm.chartProps.loading || false,
                            body: {
                              component: _vm.chartComponent,
                              props: _vm.chartProps,
                            },
                          },
                          on: {
                            open: function ($event) {
                              return _vm.$emit("open-chart")
                            },
                            close: function ($event) {
                              return _vm.$emit("close-chart")
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tableInput
                  ? _c(
                      "v-col",
                      { staticClass: "shrink" },
                      [
                        _c(
                          "Dialog",
                          _vm._g(
                            {
                              attrs: {
                                icon: "edit",
                                tooltip: "Edit values",
                                width: 500,
                                title: _vm.chartTitle,
                                body: {
                                  component: _vm.inputTableComponent,
                                  props: {
                                    value: _vm.computedValue,
                                    num_years: _vm.num_years,
                                    startYear: _vm.startYear,
                                  },
                                },
                              },
                            },
                            _vm.$listeners
                          )
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.spreadValues
                  ? _c(
                      "v-col",
                      { staticClass: "shrink" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              icon: "",
                                              color: "primary",
                                              small: "",
                                            },
                                            on: { click: _vm.repeatFirst },
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("content_copy"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              316941247
                            ),
                          },
                          [_c("span", [_vm._v("Repeat first year")])]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.extraButton
                  ? _c(
                      "v-col",
                      { staticClass: "shrink" },
                      [_vm._t("extraButton")],
                      2
                    )
                  : _vm._e(),
                !_vm.spreadValues
                  ? _c(
                      "v-col",
                      { staticClass: "shrink" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn-toggle",
                                        {
                                          attrs: { color: "primary" },
                                          model: {
                                            value: _vm.repeat,
                                            callback: function ($$v) {
                                              _vm.repeat = $$v
                                            },
                                            expression: "repeat",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  small: "",
                                                  icon: "",
                                                  value: true,
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("mdi-repeat")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4224379487
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v("Active: same value for all years"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          !_vm.chartVisible
            ? _c(
                "v-col",
                { staticClass: "grow" },
                [
                  _vm._t("inputPrepend"),
                  _c(
                    "v-row",
                    {
                      staticStyle: { "overflow-x": "auto" },
                      attrs: { align: "baseline" },
                    },
                    [
                      this.value
                        ? _vm._l(_vm.numInputs, function (year, index) {
                            return _c(
                              "v-col",
                              {
                                key: year,
                                staticClass: "py-0 mx-1",
                                staticStyle: { "min-width": "150px" },
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "d-flex",
                                    attrs: { flat: "" },
                                  },
                                  [
                                    !_vm.nullable ||
                                    (_vm.nullable && _vm.nullValue)
                                      ? _vm._t(
                                          "default",
                                          function () {
                                            return [
                                              _c("v-text-field", {
                                                attrs: {
                                                  "error-messages":
                                                    _vm.errorMessages != null &&
                                                    _vm.errorMessages[index] !=
                                                      null
                                                      ? _vm.errorMessages[index]
                                                          .messages
                                                      : null,
                                                  label: _vm.inputLabel(year),
                                                  suffix: _vm.suffix,
                                                  type: _vm.type,
                                                  readonly: _vm.readonly,
                                                  min: _vm.min,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.setYearValue(
                                                      $event,
                                                      year - 1
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.computedValue[year - 1],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.computedValue,
                                                      year - 1,
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "computedValue[year - 1]",
                                                },
                                              }),
                                            ]
                                          },
                                          {
                                            year: year,
                                            value: _vm.value,
                                            suffix: _vm.suffix,
                                            type: _vm.type,
                                            readonly: _vm.readonly,
                                            errorMessages:
                                              _vm.errorMessages &&
                                              _vm.errorMessages[index]
                                                ? _vm.errorMessages[index]
                                                    .messages
                                                : null,
                                            label: _vm.inputLabel(year),
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.chartVisible
        ? _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _vm.chartable
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12" } },
                    [
                      _c("PlotlyWrapper", {
                        attrs: {
                          data: _vm.computedChartData,
                          layout: _vm.computedChartLayout,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }